import { render, staticRenderFns } from "./Variant.vue?vue&type=template&id=ebd1cc50&scoped=true&"
import script from "./Variant.vue?vue&type=script&lang=js&"
export * from "./Variant.vue?vue&type=script&lang=js&"
import style0 from "./Variant.vue?vue&type=style&index=0&id=ebd1cc50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd1cc50",
  null
  
)

export default component.exports